import { isRef, unref } from 'vue'
import get from 'lodash/get'
import pickBy from 'lodash/pickBy'
import identity from 'lodash/identity'
import { getMediaSeoImage } from '@/assets/media'

export function createMusicEventFromPage(data, minPrice, tixSale) {
  const saleIsAvailable = unref(tixSale.saleIsAvailable)
  const page = isRef(data) ? unref(data) : data
  const minimumPrice = isRef(minPrice) ? unref(minPrice) : minPrice
  const musicians = get(page, 'production.musicians', [])
  const performer =
    typeof musicians === 'object' && musicians.length > 0
      ? musicians.map(function ({ title }) {
          // note that there are organisation type yet
          return {
            '@type': 'Person',
            name: title,
          }
        })
      : undefined

  const works = get(page, 'production.works', [])
  const workPerformed =
    typeof works === 'object' && works.length > 0
      ? works.map(function ({ title, parent }) {
          return {
            '@type': 'CreativeWork',
            name: parent && parent.id ? parent.title : title,
          }
        })
      : undefined

  const offers =
    typeof minimumPrice === 'number'
      ? {
          '@type': 'Offer',
          url: get(page, 'url'),
          category: 'primary',
          price: minimumPrice.toFixed(2),
          priceCurrency: 'EUR',
          // todo: use "less hacky" way to render something equivalent as twig logic: '1 january this year'|date("Y-m-d\\TH:i")
          validFrom: `${new Date().getFullYear()}-01-01T00:00:00`,
          // old site with SRO only checked if availability status code was "sold_out", if not it was on sale:
          // context.sro_status.availability.code|default != 'sold_out' ? 'http://schema.org/InStock' : 'http://schema.org/SoldOut'
          availability: saleIsAvailable === true ? 'http://schema.org/InStock' : 'http://schema.org/SoldOut',
        }
      : undefined

  const eventStatusMap = {
    _fallback_: 'https://schema.org/EventScheduled',
    Corona: 'https://schema.org/EventPostponed',
    Geannuleerd: 'https://schema.org/EventCancelled',
    Verplaatst: 'https://schema.org/EventRescheduled',
  }

  const musicEvent = {
    '@context': 'http://schema.org',
    '@type': 'MusicEvent',
    name: page.title,
    identifier: {
      '@type': 'PropertyValue',
      propertyID: 'Tix Event Identifier',
      value: get(page, 'eventIdentifier'),
    },
    image: (page?.production?.image || page?.production?.images?.length ? [page?.production?.image, ...(page?.production?.images || [])] : [page?.image])
      .map((image) => getMediaSeoImage(image).url)
      .filter(identity),
    description: page?.production?.introduction || page?.production?.description || page?.introduction || page?.description,
    startDate: get(page, 'eventDate'),
    endDate: get(page, 'eventEndDate') || get(page, 'eventDate'),
    url: get(page, 'url'),
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode', // todo: also support OnlineEventAttendanceMode and MixedEventAttendanceMode... but unknown yet how to determine this
    location: {
      '@type': 'MusicVenue',
      name: 'Het Concertgebouw',
      address: 'Concertgebouwplein 10, 1071 LN Amsterdam, The Netherlands',
    },
    offers,
    performer,
    workPerformed,

    organizer: page?.production?.organizer?.title ? { '@type': 'Organization', name: page?.production?.organizer?.title } : undefined,
    eventStatus: eventStatusMap[page?.iConcertStatus] || eventStatusMap._fallback_,
  }

  // remove all "falsey" properties from MusicEvent
  return pickBy(musicEvent, identity)
}
